
import { KeyValue } from '@/main/models/common';

export enum EntityTypeTypes {
  GET_ENTITY_TYPE = '@entityType/GET_ENTITY_TYPE',
  SAVE_ENTITY_TYPE = '@entityType/SAVE_ENTITY_TYPE',
  RESET_REDUCER_ENTITY_TYPE = '@entityType/RESET_REDUCER_ENTITY_TYPE'
}

export interface EntityTypeState {
  readonly entityType: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetEntityType {
  type: typeof EntityTypeTypes.GET_ENTITY_TYPE;
}

export interface SaveEntityType {
  type: typeof EntityTypeTypes.SAVE_ENTITY_TYPE;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerEntityType {
  type: typeof EntityTypeTypes.RESET_REDUCER_ENTITY_TYPE;
}

export type EntityTypeActionTypes =
  | GetEntityType
  | SaveEntityType
  | ResetReducerEntityType;
